import { render } from "./OldHouseTable.vue?vue&type=template&id=923a8fcc"
import script from "./OldHouseTable.vue?vue&type=script&lang=js"
export * from "./OldHouseTable.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__